import React, { useState, useEffect } from 'react';
import DatabaseService from '../../services/databaseService';
import  supabase  from '../../../supabase-client';
import { initializeAdmin } from '../../utils/seedAdmin';
import AdminService from '../../services/adminService';

const DatabaseDebugger = () => {
  const [books, setBooks] = useState([]);
  const [selectedBook, setSelectedBook] = useState(null);
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Get all books to see what's in the database
  const fetchBooks = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await DatabaseService.getPublishedBooks();
      console.log('📚 ALL BOOKS FROM DATABASE:', data);
      setBooks(data);
    } catch (err) {
      console.error('Error fetching books:', err);
      setError('Error al obtener libros: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  // Get specific book by ID
  const fetchBookById = async (id) => {
    setLoading(true);
    setError(null);
    try {
      const data = await DatabaseService.getBookById(id);
      console.log(`📖 BOOK BY ID ${id}:`, data);
      setSelectedBook(data);
    } catch (err) {
      console.error('Error fetching book by ID:', err);
      setError('Error al obtener libro: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  // Get all admins from dataadmin table
  const fetchAdmins = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data, error } = await supabase
        .from('dataadmin')
        .select('*');
      
      if (error) {
        throw error;
      }
      
      console.log('👥 ALL ADMINS FROM DATABASE:', data);
      setAdmins(data);
    } catch (err) {
      console.error('Error fetching admins:', err);
      setError('Error al obtener administradores: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  // Initialize admin manually
  const initializeAdminManually = async () => {
    setLoading(true);
    setError(null);
    try {
      console.log('🔧 Initializing admin manually...');
      const result = await initializeAdmin();
      console.log('🔧 Initialize result:', result);
      if (result) {
        alert('Admin inicializado correctamente!');
        fetchAdmins(); // Refresh the admin list
      } else {
        alert('Error al inicializar admin');
      }
    } catch (err) {
      console.error('Error initializing admin:', err);
      setError('Error al inicializar admin: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  // Test login credentials
  const testLogin = async () => {
    setLoading(true);
    setError(null);
    try {
      console.log('🧪 Testing login credentials...');
      const result = await AdminService.authenticateAdmin('admin@lithay.com', 'admin123');
      console.log('🧪 Login test result:', result);
      if (result.success) {
        alert('¡Login exitoso! Las credenciales funcionan.');
      } else {
        alert('Login falló: ' + result.error);
      }
    } catch (err) {
      console.error('Error testing login:', err);
      setError('Error probando login: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  // Emergency function to force create admin
  const forceCreateAdmin = async () => {
    setLoading(true);
    setError(null);
    try {
      console.log('🆘 EMERGENCY: Force creating admin...');
      
      // Try to insert directly without checking if exists
      const { data, error } = await supabase
        .from('dataadmin')
        .insert([
          {
            email_admin: 'admin@lithay.com',
            password_admin: 'admin123'
          }
        ])
        .select('*');
      
      console.log('🆘 Force create result:', { data, error });
      
      if (error) {
        alert('❌ Error: ' + error.message + '\n\nEs posible que la tabla dataadmin no exista en tu Supabase.');
      } else {
        alert('✅ ¡Admin creado exitosamente!\n\nEmail: admin@lithay.com\nPassword: admin123');
        fetchAdmins(); // Refresh the admin list
      }
      
    } catch (err) {
      console.error('Error force creating admin:', err);
      alert('❌ Error crítico: ' + err.message);
      setError('Error forzando creación de admin: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBooks();
  }, []);

  const renderBookData = (book) => {
    if (!book) return null;
    
    return (
      <div className="bg-gray-100 p-4 rounded-lg mt-4">
        <h3 className="font-bold mb-2">Datos crudos del libro:</h3>
        <pre className="text-xs overflow-auto">
          {JSON.stringify(book, null, 2)}
        </pre>
        <div className="mt-4 grid grid-cols-2 gap-4">
          <div>
            <strong>Campos importantes:</strong>
            <ul className="text-sm mt-2">
              <li><strong>available_product:</strong> {String(book.available_product)}</li>
              <li><strong>stock_count_product:</strong> {book.stock_count_product}</li>
              <li><strong>on_sale_product:</strong> {String(book.on_sale_product)}</li>
              <li><strong>review_count_product:</strong> {book.review_count_product}</li>
              <li><strong>title_product:</strong> {book.title_product}</li>
              <li><strong>price_original_product:</strong> {book.price_original_product}</li>
            </ul>
          </div>
          <div>
            <strong>Estados calculados:</strong>
            <ul className="text-sm mt-2">
              <li><strong>isAvailable:</strong> {String(book.available_product === true)}</li>
              <li><strong>hasStock:</strong> {String(book.stock_count_product > 0)}</li>
              <li><strong>isOnSale:</strong> {String(book.on_sale_product === true)}</li>
              <li><strong>inStock:</strong> {String(book.available_product === true && book.stock_count_product > 0)}</li>
            </ul>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">🔍 Database Debugger</h1>
      
      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          {error}
        </div>
      )}

      {loading && (
        <div className="bg-blue-100 border border-blue-400 text-blue-700 px-4 py-3 rounded mb-4">
          Cargando...
        </div>
      )}

      <div className="mb-6">
        <h2 className="text-lg font-semibold mb-2">Todos los libros ({books.length}):</h2>
        <button 
          onClick={fetchBooks}
          className="bg-blue-500 text-white px-4 py-2 rounded mr-2 mb-4"
        >
          Recargar libros
        </button>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {books.map(book => (
            <div 
              key={book.id_product} 
              className="border p-3 rounded cursor-pointer hover:bg-gray-50"
              onClick={() => fetchBookById(book.id_product)}
            >
              <h3 className="font-medium">{book.title_product || 'Sin título'}</h3>
              <p className="text-sm text-gray-600">{book.author_product || 'Sin autor'}</p>
              <div className="text-xs mt-2">
                <span className={`inline-block px-2 py-1 rounded ${book.available_product ? 'bg-green-200' : 'bg-red-200'}`}>
                  {book.available_product ? 'Disponible' : 'No disponible'}
                </span>
                <span className="ml-2">Stock: {book.stock_count_product || 0}</span>
                {book.on_sale_product && (
                  <span className="ml-2 bg-yellow-200 px-2 py-1 rounded">En oferta</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedBook && (
        <div className="border-t pt-6">
          <h2 className="text-lg font-semibold mb-2">Libro seleccionado:</h2>
          {renderBookData(selectedBook)}
        </div>
      )}
      
      {/* Admin Section */}
      <div className="border-t pt-6 mt-6">
        <h2 className="text-lg font-semibold mb-2">🔐 Administradores ({admins.length}):</h2>
        <div className="mb-4">
          <button 
            onClick={fetchAdmins}
            className="bg-red-500 text-white px-4 py-2 rounded mr-2 mb-2"
          >
            Cargar administradores
          </button>
          <button 
            onClick={initializeAdminManually}
            className="bg-green-500 text-white px-4 py-2 rounded mr-2 mb-2"
          >
            Crear admin por defecto
          </button>
          <button 
            onClick={testLogin}
            className="bg-yellow-500 text-white px-4 py-2 rounded mr-2 mb-2"
          >
            Probar login
          </button>
          <button 
            onClick={forceCreateAdmin}
            className="bg-orange-600 text-white px-4 py-2 rounded mr-2 mb-2"
          >
            🆘 EMERGENCIA: Crear admin directo
          </button>
        </div>
        
        {admins.length > 0 && (
          <div className="bg-orange-50 p-4 rounded-lg">
            <h3 className="font-bold mb-2">Datos de administradores:</h3>
            <pre className="text-xs overflow-auto bg-white p-2 rounded">
              {JSON.stringify(admins, null, 2)}
            </pre>
            
            {admins.map((admin, index) => (
              <div key={admin.id || index} className="mt-4 p-3 bg-white rounded border">
                <h4 className="font-semibold">Admin {index + 1}:</h4>
                <ul className="text-sm mt-2">
                  <li><strong>ID:</strong> {admin.id || 'N/A'}</li>
                  <li><strong>Email:</strong> {admin.email_admin || 'N/A'}</li>
                  <li><strong>Password:</strong> {admin.password_admin || 'N/A'}</li>
                  <li><strong>Campos disponibles:</strong> {Object.keys(admin).join(', ')}</li>
                </ul>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default DatabaseDebugger;

